import {
  ColumnDataType,
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'

class Polygonize extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.polygonize',
        group: 'Spatial Constructors',
        title: 'ST Polygonize',
        description: `
      This component adds a new column with polygons, created from a column containing arrays of lines representing polygon edges.
      `
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'geo',
          type: WorkflowComponentParamType.Column,
          title: 'Geo column',
          parent: 'source',
          dataType: [ColumnDataType.Geography, ColumnDataType.Geometry]
        }
      ]
    )
  }

  getInnerSql({ params, connection, envVars }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
        return `SELECT
              ${connection.quoteName(envVars.analyticsToolboxDataset as string)}.ST_POLYGONIZE(
                [${params.geo}]
              ) ${params.geo}_polygon, *
            FROM ${connection.quoteName(params.source as string)}`
      case Provider.Postgres:
        return `SELECT
                  ST_POLYGONIZE(
                    ARRAY[ST_NODE(${params.geo})]
                  ) ${params.geo}_polygon, *
                FROM ${connection.quoteName(params.source as string)}`
      case Provider.Redshift:
        return `SELECT
                  ${connection.quoteName(envVars.analyticsToolboxDataset as string)}.ST_POLYGONIZE(
                    ${params.geo}
                  ) ${params.geo}_polygon, *
                FROM ${connection.quoteName(params.source as string)}`
      default:
        return null
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  requiredAnalyticsToolboxVersion(provider: Provider): string | null {
    return '1.0.0'
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ columns, params, connection }: GetOutputSchemaParams): TableSchema {
    return addColumn(columns.source, {
      name: `${params.geo}_polygon`,
      type: connection.getGeoDataType()
    })
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.Redshift]
  }
}

export { Polygonize }
